import { render, staticRenderFns } from "./SelectorOptionsError.vue?vue&type=template&id=40135980"
import script from "./SelectorOptionsError.vue?vue&type=script&lang=js"
export * from "./SelectorOptionsError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports